export default {
  methods: {

    checkStocks () {
      const warehouseCode = this.stockRequest.headers.origin_code

      if (!warehouseCode) {
        this.$refs.formStockRequest.setErrors({
          'headers.origin': ['Please select transfer from first']
        })

        return this.swalInvalid()
      }

      const productCodes = this.$refs.componentProducts.getFinalProducts().map(
        detail => detail.product_code
      )

      this.getStocks(this, warehouseCode, productCodes).finally(() => {
        this.$refs.componentProducts.setStocksOfProducts(this.options.stocks)
      })
    },

    createRequest () {
      this.editing = false

      this.stockRequest = Object.assign(this.stockRequest, {
        id: '',
        stage: 0,
        references: {
          document_number: '',
          transfer_number: '',
          sap_doc_entry: '',
          transaction_number: ''
        },
        headers: {
          group: '',
          group_name: '',
          group_code: '',
          remarks: ''
        },
        delivery_details: {
          date: '',
          vehicle: '',
          vehicle_plate: '',
          vehicle_name: '',
          driver: '',
          driver_name: '',
          mobile_number: '',
          helper: ''
        },
        details: Array.from({ length: 5 }).map(
          () => ({
            product: null,
            quantity: null,
            onhand_quantity: 0
          })
        ),
        remarks: ''
      })

      this.getOrigins(this)

      this.getDestinations(this).finally(() => {
        this.getProducts(this)
      })

      this.$bvModal.show('modalRequest')
    },

    submitRequest (remarks = '') {
      const { id, headers, delivery_details } = this.stockRequest
      return this.$refs.srPending.create({
        id: id,
        origin: headers.origin,
        destination: headers.destination,
        remarks: remarks,
        delivery_details: {
          date: delivery_details.date,
          vehicle: '',
          vehicle_plate: delivery_details.vehicle_plate,
          vehicle_name: delivery_details.vehicle_name,
          driver: '',
          driver_name: delivery_details.driver_name,
          mobile_number: delivery_details.mobile_number,
          helper: delivery_details.helper
        },
        details: this.$refs.componentProducts.getFinalProducts(),
        active: 1
      }).then(() => {
        this.currentTabIndex = 0
      }).catch(
        errors => {
          if (errors.errors) {
            if (this.$refs.formStockRequest) {
              this.$refs.formStockRequest.setErrors({
                'headers.origin': errors.errors?.origin || [],
                'headers.category': errors.errors?.category || [],
                'headers.destination': errors.errors?.destination || []
              })
            }

            this.setProductErrors(errors.errors)
            this.$refs.formDelivery.setErrors(errors.errors)
          }
        }
      )
    }
  }
}
